import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { actionSubmitExtRef, actionGetPatientCompleteInfo } from 'store/actions/usersActions';
import patientService from 'services/patientService';
import PatientExtRefForm from './Form/PatientExtRefForm';
import PatientInfoSection from './Form/PatientInfoSection';
import PatientEmailForm from './Form/PatientEmailForm';

/**
 * @component PatientUsersForm
 * @description Form for editing the external references of a patient's associated
 * practices. Since `associated_details` is no longer included in the Redux list
 * payload, this component fetches the full details on mount via
 * `patientService.getPatientDetails` and renders the ext-ref inputs once loaded.
 */
const PatientUsersForm = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.usersPatientsReducer.editData);

  const history = useHistory();

  const [practices, setPractices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  /**
   * Loads all associated practices for the patient in Redux edit state.
   * Uses a high detailsLimit to capture all practices in a single request.
   */
  useEffect(() => {
    if (!userData?.auth_user_id) return;

    const load = async () => {
      setLoading(true);
      setFetchError(null);
      try {
        const response = await patientService.getPatientDetails(
          userData.auth_user_id,
          0,
          100,
          0,
          1
        );
        
        // Corrección del triple anidamiento de data: Axios -> Express -> Service
        const payload = response?.data?.data;
        const resultData = payload?.data?.[0];
        
        // Cambio clave: apuntamos a 'practices' en lugar de 'associated_details'
        setPractices(resultData?.practices ?? []);
      } catch (e) {
        setFetchError('Could not load practice data.');
      } finally {
        setLoading(false);
      }
    };

    load();
    dispatch(actionGetPatientCompleteInfo(userData?.auth_user_id));
  }, [userData?.auth_user_id]);

  return (
    <div className="content user-manual-edit">

      {loading ? (
        <div className="text-center py-4">
            <Spinner color="primary" />
        </div>
        ) : fetchError ? (
        <div className="text-danger">{fetchError}</div>
        ) : (
          <>
            <PatientInfoSection userData={userData}/>
            <PatientEmailForm userData={userData}/>
            <PatientExtRefForm userData={userData} practices={practices}/>
          </>
        )}
      
    </div>
  );
};

export default PatientUsersForm;